module.exports = __webpack_public_path__ + "static/img/title.5f0cd8c2.png";